import { Outlet } from '@tanstack/react-router';
import { TopBar } from './TopBar';
import { Drawer } from './Drawer';

export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col bg-surface text-neutral-900">
      <TopBar />
      <div className="flex flex-1">
        <Drawer />
        <main className="flex-1 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
